export default function Link(theme) {
    return {
        MuiLink: {
            defaultProps: {
                underline: 'none',
            },
            styleOverrides: {
                root: {
                    color: theme.palette.primary.darker,
                    fontWeight: 600,
                    userSelect: 'text',
                    cursor: 'pointer',
                    fontFamily: 'Lato',
                    textTransform: 'capitalize',
                    padding: theme.spacing(0.5, 1),
                    transition: theme.transitions.create(['color', 'background-color'], {
                        duration: theme.transitions.duration.shorter,
                    }),
                    '&:hover': {
                        color: theme.palette.primary.highlight,
                        textDecoration: 'none',
                    },
                    '&:active': {
                        color: theme.palette.primary.darker,
                    },
                    '&:focus-visible': {
                        outline: `2px solid ${theme.palette.primary.light}`,
                        outlineOffset: '2px',
                    },
                    '&.Mui-disabled': {
                        color: theme.palette.text.disabled,
                        pointerEvents: 'none',
                    },
                },
            },
        },
    };
}